/* eslint-disable no-param-reassign,@typescript-eslint/naming-convention,import/extensions,import/no-unresolved */
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit.min.js';
import 'swiper/css';
import 'swiper/css/navigation';
import MicroModal from 'micromodal';
import Macy from 'macy';
import Cookies from 'js-cookie';

import '../scss/redesign.scss';

import './lib/icons.js';
import './lib/multi-level-menu.js';

// import './form.tsx';
import './widgets.ts';

import svgxhr from './lib/svgxhr.js';
import Panel from './modules/Panel.js';
import PanelSwiper from './modules/PanelSwiper.js';
import Accordion from './modules/Accordion.js';
import GallerySwiper from './modules/GallerySwiper.js';
import AnimateScroll from './modules/AnimateScroll.js';
import PageTabs from './modules/PageTabs.js';
import Affix from './modules/Affix.js';
import ReviewSwiper from './modules/ReviewSwiper.js';
import FilteredResults from './modules/FilteredResults.js';
import OfferModal from './modules/OfferModal.js';
import OfferSwiperSection from './modules/OfferSwiperSection.js';
import ReadMore from './modules/ReadMore.js';
import SiteNavigation from './modules/SiteNavigation.js';
import HomeSwiper from './modules/HomeSwiper.js';
import ReviewsSwiper from './modules/ReviewsSwiper.js';
import ActivityModal from './modules/ActivityModal.js';
import ResponsiveVideo from './modules/ResponsiveVideo.js';
import SwiperAndCopy from './modules/SwiperAndCopy.js';
import Faqs from './modules/Faqs.js';
import BasketControls from './modules/BasketControls.js';
import 'tippy.js/dist/tippy.css';
import AccountTabs from './modules/AccountTabs.js';
import TermsAndConditionsModal from './modules/TermsAndConditionsModal.js';
import PackageModal from './modules/PackageModal.js';
import LoginModal from './modules/LoginModal.js';
import LogoutModal from './modules/LogoutModal.js';
import Tooltip from './modules/Tooltip.js';
import Countdown from './modules/Countdown.js';
import TimelineSwiper from './modules/TimelineSwiper.js';
import micromodalOptions from './lib/micromodal-options.js';
import MembershipTerms from './modules/MembershipTerms.js';
import MembershipInfo from './modules/MembershipInfo.js';
import PrimaryAction from './modules/PrimaryAction.js';
import ProductHeader from './modules/ProductHeader.js';
import BundleForm from './modules/BundleForm.js';
import Snow from './modules/Snow.js';
import InView from './modules/InView.js';
import SwipeCards from './modules/SwipeCards.js';

window.snowdomeWW = {
  init() {
    this.setBodyWidth();
    this.helpers.initSvg();

    window.addEventListener('resize', () => {
      this.setBodyWidth();
    }, { passive: true });

    // eslint-disable-next-line no-return-assign
    (document.querySelectorAll('#call-to-action-modal') ?? []).forEach((modal) => {
      if (Cookies.get('cta-shown') !== 'true') {
        MicroModal.show(modal, micromodalOptions);
      }
    });
    (document.querySelectorAll('.panel') ?? []).forEach((el) => el.panel = new Panel(el));
    (document.querySelectorAll('.section--bundles .section__form') ?? []).forEach((form) => new BundleForm(form));
    (document.querySelectorAll('.panel-swiper') ?? []).forEach((el) => new PanelSwiper(el));
    (document.querySelectorAll('.timeline-swiper' ?? [])).forEach((el) => new TimelineSwiper(el));
    (document.querySelectorAll('.accordion') ?? []).forEach((el) => new Accordion(el));
    (document.querySelectorAll('.section--swiper-and-copy') ?? []).forEach((el) => new SwiperAndCopy(el));
    (document.querySelectorAll('.gallery-swiper') ?? []).forEach((el) => new GallerySwiper(el));
    (document.querySelectorAll('.section--offer-swiper, .section--special-swiper') ?? []).forEach(
      (el) => new OfferSwiperSection(el),
    );
    (document.querySelectorAll('.read-more') ?? []).forEach((el) => new ReadMore(el));
    (document.querySelectorAll('.page-tabs') ?? []).forEach((el) => new PageTabs(el));
    (document.querySelectorAll('[data-affix]') ?? []).forEach((el) => new Affix(el));
    (document.querySelectorAll('.review-swiper') ?? []).forEach((el) => new ReviewSwiper(el));
    (document.querySelectorAll('.modal .offer-content') ?? []).forEach((el) => new OfferModal(el));
    (document.querySelectorAll('.modal .package-content') ?? []).forEach((el) => new PackageModal(el));
    (document.querySelectorAll('#filtered-results') ?? []).forEach((el) => new FilteredResults(el));
    (document.querySelectorAll('#site-navigation') ?? []).forEach((el) => new SiteNavigation(el));
    (document.querySelectorAll('.home-swiper') ?? []).forEach((el) => new HomeSwiper(el));
    (document.querySelectorAll('#modal-activity-selector') ?? []).forEach((el) => new ActivityModal(el));
    (document.querySelectorAll('main#checkout-content #modal-terms-and-conditions') ?? []).forEach(
      (el) => new TermsAndConditionsModal(el, true),
    );
    (document.querySelectorAll('main:not(#checkout-content) #modal-terms-and-conditions') ?? []).forEach(
      (el) => new TermsAndConditionsModal(el, false),
    );
    // (document.querySelectorAll('#checkout-content') ?? []).forEach((el) => new TermsAndConditionsModal(el, true));
    (document.querySelectorAll('video[data-mobile-src]') ?? []).forEach((el) => new ResponsiveVideo(el));
    (document.querySelectorAll('.site-review-slider') ?? []).forEach((el) => new ReviewsSwiper(el));
    (document.querySelectorAll('.faqs') ?? []).forEach((el) => new Faqs(el));
    (document.querySelectorAll('.basket-menu') ?? []).forEach((el) => new BasketControls(el));
    (document.querySelectorAll('#product-parent-header') ?? []).forEach((el) => new AccountTabs(el));
    (document.querySelectorAll('#product-header') ?? []).forEach((el) => new ProductHeader(el));
    (document.querySelectorAll('#modal-login-form') ?? []).forEach((el) => new LoginModal(el, false));
    (document.querySelectorAll('#modal-logout') ?? []).forEach((el) => new LogoutModal(el, false));
    (document.querySelectorAll('#membership-terms') ?? []).forEach((el) => new MembershipTerms(el));
    (document.querySelectorAll('#membership-overview') ?? []).forEach((el) => new MembershipInfo(el));
    (document.querySelectorAll('.tooltip') ?? []).forEach((el) => new Tooltip(el, false));
    (document.querySelectorAll('.countdown') ?? []).forEach((el) => new Countdown(el));
    (document.querySelectorAll('.js-snow') ?? []).forEach((el) => new Snow(el));
    (document.querySelectorAll('[data-in-view], [data-in-view-class]') ?? []).forEach((el) => new InView(el));
    (document.querySelectorAll('[data-component="swipe-cards"]') ?? []).forEach((el) => new SwipeCards(el));
    (document.querySelectorAll('.section--review-grid .section__grid') ?? []).forEach((el) => new Macy({
      container: el,
      columns: 3,
      margin: {
        x: 20,
        y: 20,
      },
      breakAt: {
        991: {
          columns: 2,
        },
      },
    }));

    (document.querySelectorAll('#primary-action, #primary-action-mobile, .js-primary-action') ?? [])
      .forEach((btn) => new PrimaryAction(btn));
    MicroModal.init(micromodalOptions);

    this.nav.init();
    // this.headerVideo.init();
    this.miniBasket();

    const animateScroll = new AnimateScroll();
    animateScroll.init();
  },
  headerVideo: {
    init: () => {
      const video = document.querySelector('.header-video');

      if (video !== null) {
        const sources = video.getElementsByTagName('source');

        if (window.outerWidth < 481) {
          sources[0].src = video.dataset.mobileSrc ?? sources[0].src;
        }

        video.load();
        video.play();
      }
      return true;
    },
  },
  miniBasket: () => {
    const siteHeader = document.querySelector('#site-header');
    const trigger = document.querySelector('.minibasket-trigger');

    if (trigger !== null && siteHeader !== null) {
      const overlay = siteHeader.querySelector('.overlay');

      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();

        if (siteHeader !== null) {
          // eslint-disable-next-line max-len
          overlay.style.height = siteHeader.classList.contains('dropdown-basket-active') ? 0 : `${document.documentElement.offsetHeight}px`;
          siteHeader.classList.toggle('dropdown-basket-active');
          ev.currentTarget.nextElementSibling.classList.toggle('open');
        }
      });

      overlay.addEventListener('click', () => {
        trigger.click();
      });
    }
  },
  nav: {
    init: () => {
      const siteHeaderSelector = '#site-header';
      const siteHeader = document.querySelector(siteHeaderSelector);
      const mobileNav = document.querySelector('#mobile-nav');
      const menuEl = document.getElementById('mobile-nav');

      if (!menuEl) return;

      menuEl.mlmenu = new window.MLMenu(menuEl, {
        breadcrumbsCtrl: false, // show breadcrumbs
        backCtrl: true, // show back button
        onBackClick() {
          this.backCtrl.innerText = this.menusArr[this.menusArr[this.current_menu].backIdx].name;
        },
        onSubmenuClick(ev, itemName) {
          menuEl.querySelector('.menu__back').innerText = itemName;
        }, // callback: item that doesn´t have a submenu gets clicked - onItemClick([event], [inner HTML of the clicked item])
      });

      if (document.querySelector("[href='#mobile-nav']") !== null) {
        document.querySelectorAll("[href='#mobile-nav']").forEach((el) => {
          el.addEventListener('click', (ev) => {
            ev.preventDefault();
            let height = 0;

            mobileNav.querySelectorAll('.menu__level').forEach((level) => {
              level.style.height = 'auto';

              if (level.offsetHeight > height) {
                height = level.offsetHeight;
              }

              level.style.height = '100%';
            });

            mobileNav.style.height = (!siteHeader.classList.contains('dropdown-active')) ? `${(height + 45)}px` : '0';

            siteHeader.classList.toggle('dropdown-active');
            el.classList.toggle('active');
          });
        });
      }

      window.addEventListener('scroll', () => {
        if (siteHeader) {
          if (window.scrollY > 10) {
            siteHeader.classList.add('affixed');
          } else {
            siteHeader.classList.remove('affixed');
          }
        }
      }, { passive: true });
    },
  },
  setBodyWidth: () => {
    if (document.scrollingElement) {
      const innerWidth = document.scrollingElement.clientWidth;
      document.documentElement.style.setProperty('--body-width', `${innerWidth}px`);
    }
  },
  helpers: {
    initSvg() {
      svgxhr({
        filename: './redesign-sprite.svg', // URL to fetch
        divId: 'svg-sprite',
      });
    },
  },
};

window.snowdomeWW.init();

if (typeof NodeList.prototype.forEach !== 'function') {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
